import { clearInputField, clearSelectField } from '../../helpers';

export const clearAndHideMultipleFieldInputs = (arrayOfElements) => {
  arrayOfElements.forEach(($element, _) => {
    $element.addClass('d-none');
    $('input', $element).each((_, inputElement) => {
      clearInputField(inputElement);
    });
  });
};

export const setupFatcaFiscalCountries = ($form) => {
  let $addButton = $('#add-fatca-fiscal-country', $form);
  const fiscalCountryFields = '.fatca-fiscal-country-fields';
  let $fiscalCountryFields = $(fiscalCountryFields, $form);
  let $removeButtons = $('.remove-fatca-fiscal-country', $fiscalCountryFields);
  const $fiscalTransparencyFields = $('#fiscal-transparency-questions');
  const countryArray = [$('#first-country'), $('#second-country'), $('#third-country'), $('#fourth-country')];

  $addButton.on('click', (e) => {
    e.preventDefault();

    let $hiddenFiscalCountryFields = $fiscalCountryFields.filter('.d-none');

    if ($hiddenFiscalCountryFields.length == 1) {
      $addButton.addClass('d-none');
    };

    $hiddenFiscalCountryFields.first().removeClass('d-none');
  });

  $removeButtons.on('click', (e) => {
    e.preventDefault();

    let $removeButton = $(e.target);
    let $fields = $removeButton.closest(fiscalCountryFields);

    $fields.addClass('d-none');

    toggleFiscalTransparancyFIelds(countryArray, $fiscalTransparencyFields, $form);

    $('input', $fields).each((_, inputElement) => {
      clearInputField(inputElement);

      const changeEvent = new Event('change');

      $('.fatca-fiscal-country-fields select', $form).each((_, selectElement) => {
        clearSelectField(selectElement);
        selectElement.selectedIndex = 0;
        selectElement.dispatchEvent(changeEvent);
      });
    });

    $addButton.removeClass('d-none');
  });

  $form.on('submit', (e) => {
    $('.fatca-fiscal-country-fields.d-none select option[selected]', $form).each((_, option) => {
      option.value = '';
    });
  });
};

export const setUpFiscalTransparencyFields = ($form) => {
  const $fiscalTransparencyFields = $('#fiscal-transparency-questions');
  const countryArray = [$('#first-country'), $('#second-country'), $('#third-country'), $('#fourth-country')];

  toggleFiscalTransparancyFIelds(countryArray, $fiscalTransparencyFields, $form);
};

export const toggleIsTaxableFields = ($form) => {
  const $isFiscallyTransparent = $('input[type=radio]', '#is_fiscally_transparent', $form);
  const $reasonIsNotTaxableButtons = $('#reason_for_not_being_taxable', $form);
  const $isTaxableButtons = $('#is_taxable_buttons', $form);


  $isFiscallyTransparent.on('change', (_e) => {
    if ($isFiscallyTransparent[1].checked) {
      $isTaxableButtons.removeClass('d-none');
    } else {
      clearAndHideMultipleFieldInputs([$isTaxableButtons, $reasonIsNotTaxableButtons]);
    }
  })
};

export const toggleReasonIsNotTaxableFields = ($form) => {
  const $isTaxableButtons = $('input[type=radio]', '#is_taxable_buttons', $form);
  const $reasonIsNotTaxableButtons = $('#reason_for_not_being_taxable', $form);

  $isTaxableButtons.on('change', (_e) => {
    if ($isTaxableButtons[1].checked) {
      $reasonIsNotTaxableButtons.removeClass('d-none');
    } else {
      clearAndHideMultipleFieldInputs([$reasonIsNotTaxableButtons]);
    }
  })
};

const toggleFiscalTransparancyFIelds = (countryArray, $fiscalFields, $form) => {
  const $isTaxableButtons = $('#is_taxable_buttons', $form);
  const $reasonIsNotTaxableButtons = $('#reason_for_not_being_taxable', $form);

  countryArray.forEach(($country, _) => {
    $country.on('change', (_e) => {
      if (anyNonFrenchCountries(countryArray)) {
        $fiscalFields.removeClass('d-none');
      } else {
        clearAndHideMultipleFieldInputs([$fiscalFields, $isTaxableButtons, $reasonIsNotTaxableButtons]);
      }
    })
  });
};

const anyNonFrenchCountries = (countryArray) => {
  let completedCountries = countryArray.map($country => $country.val()).filter(function(value) {
    return (value !== '' && value !== 'FR');
  })

  return completedCountries.length > 0;
};
